import React from 'react';
import { CtyButton } from '../button/CtyButton';

export interface TabItem {
  key: string;
  title: string;
  id: string;  // Add id to TabItem interface
  isDisabled?: boolean;
  className?: string;
  canView?: boolean;
  endContent?: React.ReactNode;
  startContent?: React.ReactNode;
}

interface CustomTabsProps {
  tabs: TabItem[];
  selectedKey: string;
  onTabChange: (key: string) => void;
  disabledKeys?: string[];
}

const CustomTabs: React.FC<CustomTabsProps> = ({ tabs, selectedKey, onTabChange, disabledKeys = [] }) => {
  const handleTabClick = (key: string) => {
    if (!disabledKeys.includes(key)) {
      onTabChange(key);
    }
  };

  return (
    <div className="custom-tabs">
      <ul className="flex border-b w-[max-content]">
        {tabs?.map((tab) => {

          if (tab?.canView === false) return null;

          return <CtyButton
            key={tab.key}
            id={tab.id} // Assign the id to each tab
            className={`${tab.className} cursor-pointer px-4 py-2 font-semibold text-sm overflow-hidden whitespace-nowrap border-r-0${selectedKey === tab.key
              ? 'border-b-2 border-primary text-primary active-tab'
              : 'text-default-500'
              } ${disabledKeys.includes(tab.key) ? 'text-default-400 cursor-not-allowed' : ''} `}
            onPress={() => handleTabClick(tab.key)}
            isDisabled={disabledKeys.includes(tab.key) || tab?.isDisabled}
            variant='light'
            endContent={tab.endContent ?? null}
            startContent={tab.startContent ?? null}
          >
            {tab.title}
          </CtyButton>;
        })}
      </ul>
    </div>
  );
};

export { CustomTabs };